<template>
    <v-menu
        :key="`trip-duration-${entry.uid}-${variant}`"
        :model-value="open"
        location="bottom start"
        offset="6"
        :close-on-content-click="false"
        :scrim="false"
        @update:model-value="$emit('update:open', $event)"
    >
        <template #activator="{ props: menuProps }">
            <span v-if="variant === 'ware-button'" class="d-inline-flex">
                <v-btn
                    v-bind="menuProps"
                    size="default"
                    color="yellow"
                    variant="outlined"
                    @click.stop
                >
                    {{ $t("entries.distanceCalculator") }}
                </v-btn>
                <v-tooltip activator="parent" location="bottom">
                    {{ $t("entries.distanceCalculatorTooltip") }}
                </v-tooltip>
            </span>

            <span
                v-else
                v-bind="menuProps"
                class="toolbar-left-group cursor-pointer"
                @click.stop
                @mousedown.stop
                @touchstart.stop
            >
                <span class="text-white">{{ $t("entries.tripDuration") }}:&nbsp;</span>
                <span class="text-yellow">{{ tripDurationLabel }}</span>
                <v-tooltip activator="parent" location="bottom">
                    {{ $t("entries.tripDurationTooltip") }}
                </v-tooltip>
            </span>
        </template>

        <TripDurationPanel
            :entry="entry"
            :speed-kmh="speedKmh"
            :speed-readonly="speedReadonly"
            @update:speed-kmh="$emit('update:speedKmh', $event)"
        />
    </v-menu>
</template>

<script>
import { formatDurationCompact } from "@/utils";
import { computeEtaBreakdown } from "@/utils/etaCalculation";
import TripDurationPanel from "./TripDurationPanel.vue";

export default {
    name: "TripDurationMenu",
    components: {
        TripDurationPanel,
    },
    props: {
        entry: {
            type: Object,
            required: true,
        },
        open: {
            type: Boolean,
            default: false,
        },
        speedKmh: {
            type: [String, Number],
            default: "",
        },
        speedReadonly: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: "ware-button",
            validator: (value) => ["ware-button", "truck-label"].includes(value),
        },
    },
    emits: ["update:open", "update:speedKmh"],
    computed: {
        tripDurationLabel() {
            const speed = Number(this.speedKmh);
            if (!Number.isFinite(speed) || speed <= 0) return null;
            const breakdown = computeEtaBreakdown({
                distanceKm: this.entry.distance_km,
                avgSpeedKmh: speed,
            });
            if (!breakdown) return null;
            return formatDurationCompact(breakdown.totalTripSeconds);
        },
    },
};
</script>
